<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Label from 'dashboard/components-next/label/Label.vue';

// Mirrors Campaign::V1_TRANSITIONS' full status set exactly - this badge
// exists precisely because the shared CampaignCard/CampaignList (still used
// by Live Chat/SMS/Twilio) only ever knows about active/completed/processing
// and was deliberately left untouched rather than extended for these.
const props = defineProps({
  status: {
    type: String,
    required: true,
  },
});

const { t } = useI18n();

const STATUS_COLORS = {
  draft: 'slate',
  scheduled: 'blue',
  processing: 'iris',
  paused: 'amber',
  completed: 'teal',
  completed_with_errors: 'amber',
  cancelled: 'slate',
  failed: 'ruby',
};

const color = computed(() => STATUS_COLORS[props.status] || 'slate');
const label = computed(() =>
  t(`CAMPAIGN.WHATSAPP.V1_STATUS.${props.status.toUpperCase()}`)
);
</script>

<template>
  <Label :label="label" :color="color" compact />
</template>
